<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-left-double__a)">
    <path d="M14.291 2.265a1 1 0 0 1 0 1.416L5.957 12l8.334 8.32a1 1 0 0 1 0 1.415l-1.563 1.56a1 1 0 0 1-1.413 0L.709 12.708a1 1 0 0 1 0-1.416L11.315.705a1 1 0 0 1 1.413 0l1.563 1.56Z"/>
    <path d="M23.291 2.265a1 1 0 0 1 0 1.416L14.957 12l8.334 8.32a1 1 0 0 1 0 1.415l-1.563 1.56a1 1 0 0 1-1.413 0L9.709 12.708a1 1 0 0 1 0-1.416L20.315.705a1 1 0 0 1 1.413 0l1.563 1.56Z"/>
  </g>
  <defs>
    <clipPath id="chevron-left-double__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
